var _jsxFileName = "/home/runner/work/frontend-shared/frontend-shared/src/components/layout/CardActions.tsx";
import classnames from 'classnames';
import { downcastRef } from '../../util/typing';
import { jsxDEV as _jsxDEV } from "preact/jsx-dev-runtime";
/**
 * Render a group of buttons or interactive elements inside a Card
 */
export default function CardActions({
  children,
  classes,
  elementRef,
  ...htmlAttributes
}) {
  return _jsxDEV("div", {
    "data-component": "CardActions",
    ...htmlAttributes,
    className: classnames('flex items-center justify-end space-x-3', classes),
    ref: downcastRef(elementRef),
    children: children
  }, void 0, false, {
    fileName: _jsxFileName,
    lineNumber: 21,
    columnNumber: 5
  }, this);
}
//# sourceMappingURL=CardActions.js.map